// HTTP adapters report failures independently of error messages and toasts.
const listeners = new Set<() => void>();

export function subscribeRequestFailures(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyRequestFailure() {
  for (const listener of listeners) listener();
}
